/*eslint-disable react/prop-types*/
/*eslint-disable react/no-danger*/
/* eslint no-undef: 0 */
import React, { Component } from "react";
import {
  _formatArray,
  formatImageUrlByDevice,
  appendHttpsToUrl,
  buildRetailers,
  fireGTMEvent,
  BuildServerlessBookCoverImageUrl,
  renderFreeVoiceBanner,
} from "../../helpers/Helper";
import NextImage from "@components/Image/NextImage";
import RetailerImageButton from "./RetailerImageButton";
import BuyButton from "./BuyButton";
import ContextConsumer from "../NavContextConsumer/NavContextConsumer";
import POST from "../../constants/Post";
import IMAGESIZES from "../../constants/IMAGESIZES";

import styles from "./AffiliateButton.module.css";

class AffiliateButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rtlQuery: null,
    };
  }

  static defaultProps = {
    buttonType: "",
    urlType: "",
    buttonText: "",
    linkUrl: {
      url: "",
      title: "",
    },
    title: "",
    amazonLink: "",
    itunesLink: "",
    bnLink: "",
    ormLink: "",
    koboLink: "",
    image: "",
    bookListicle: false,
    author: "", //E.L old data signature for author
    authors: [],
    isbns: "",
    publisher: "",
  };

  componentDidMount() {
    if (typeof window === "undefined") {
      return; // Handle SSR case by returning false
    }
    const urlParams = new URLSearchParams(window.location.search);
    const rtlQuery = urlParams.get("rtl_btn");
    this.setState({ rtlQuery });
  }

  /* If the route query has "rtl_btn=new", then render new single buy button otherwise
  render multiple buy buttons */
  shouldRenderSingleButton = () => {
    const { rtlQuery } = this.state;
    if (rtlQuery && rtlQuery === "new") {
      return true;
    } else {
      return false;
    }
  };

  hasRetailerLinks = () => {
    let retailers = buildRetailers(this.props);
    return retailers.some((retailer) => retailer.url);
  };

  isScopedPageBuilderUrlButton = () => {
    const { className, buttonType, urlType, image, title, author, authors } =
      this.props;

    return (
      className === "PageBuilderAf" &&
      buttonType === "Url (link)" &&
      urlType === "External Link" &&
      !image &&
      !title &&
      !author &&
      (!authors || authors.length === 0)
    );
  };

  renderTitle = () => (
    <span dangerouslySetInnerHTML={{ __html: this.props.title }} />
  );

  renderAuthor = () => {
    const { author, authors } = this.props,
      authorNames = (names) =>
        names.length > 0 && (
          <span>
            <span className="author-by">By</span> {names}
          </span>
        );
    let _author;
    if (author) {
      let _authorName = author;
      if (typeof author === "string") {
        _authorName = [author];
      }
      _author = authorNames(_formatArray(_authorName, ", ", " and "));
    } else if (authors) {
      let _authorNames = authors.map((author) => {
        return typeof author === "object"
          ? author.Display_Name || author.display_name
          : author;
      });
      _author = authorNames(_formatArray(_authorNames, ", ", " and "));
    }
    return _author;
  };

  renderBookPrice = () => {
    const { salePrice, price } = this.props;
    if (salePrice && salePrice !== "") {
      return (
        <>
          <div className={styles["afb__price_sale"]}>
            <span className={styles["salePrice"]}>${salePrice}</span>
            {price && price !== "" && <span className={styles["price"]}>${price}</span>}
          </div>
        </>
      );
    }
    return <span className={styles["afb__price_check"]}>Select Your Retailer</span>;
  };

  getImageUrl = () => {
    const { urlType, image } = this.props;
    let bookCoverUrl;

    switch (urlType) {
      case "Internal Link":
        bookCoverUrl = BuildServerlessBookCoverImageUrl(
          IMAGESIZES.BC_LISTICLE,
          image?.props?.image?.Name ?? null
        );
        break;
      case "External Link":
        bookCoverUrl =
          image && typeof image === "object"
            ? image.props && image.props.image && image.props.image.Name
              ? formatImageUrlByDevice(
                  image.props.image.Name,
                  this.props.deviceSize
                )
              : null
            : typeof image === "string"
              ? image
              : null; // Checking string type because external titles will have image type string
        break;
      default:
        bookCoverUrl = null;
        break;
    }

    return bookCoverUrl;
  };

  renderBookCover = (imageWidth, imageHeight) => {
    const { buttonType, image } = this.props;

    // url buttons don't have book covers
    // if (!this.props.bookListicle) {
    if (buttonType == "Url (link)") {
      return null;
    }

    let bookCoverUrl = this.getImageUrl();
    if (bookCoverUrl) {
      const searchRegExp = /\s/gi;
      const replaceWith = "-";

      return (
        <NextImage
          ImageUrl={appendHttpsToUrl(bookCoverUrl)}
          width={imageWidth || 210}
          height={imageHeight || 320}
          Title={
            image?.props?.image?.Title ||
            this.props.title.replace(searchRegExp, replaceWith)
          }
          Alt_Text={image?.props?.image?.Alt_Text || this.props.title}
        />
      );
    }
  };
  renderUrlButton = () => {
    const { urlType, linkUrl, buttonText } = this.props;
    const isScopedPageBuilderUrlButton = this.isScopedPageBuilderUrlButton();

    let link;

    switch (urlType) {
      case "Internal Link":
        if (Object.keys(linkUrl).length > 1) {
          link = (
            <>
              <a
                className={[
                  styles["button"],
                  "button",
                  isScopedPageBuilderUrlButton
                    ? styles["pageBuilderUrlButton"]
                    : "",
                ].join(" ")}
                rel="noopener nofollow sponsored"
                href={linkUrl.url}
                title={linkUrl.title}
              >
                {buttonText}
              </a>
            </>
          );
        }
        break;
      case "External Link":
        if (linkUrl) {
          link = (
            <>
              <a
                className={[
                  styles["button"],
                  "button",
                  styles["external"],
                  isScopedPageBuilderUrlButton
                    ? styles["pageBuilderUrlButton"]
                    : "",
                ].join(" ")}
                rel="noopener nofollow sponsored"
                href={linkUrl}
                target="_blank"
                data-vars-outbound-url={linkUrl}
                data-vars-outbound-text={buttonText}
              >
                {buttonText}
              </a>
            </>
          );
        }
        break;
      default:
        link = null;
        break;
    }

    return link;
  };

  renderSingleBuyButton = () => {
    if (this.props.buttonType == "Url (link)") {
      return this.renderUrlButton();
    } else {
      if (this.hasRetailerLinks()) {
        return (
          <BuyButton
            retailerModalHtml={this.renderRetailerModalHtml()}
            isTablet={this.props.isTablet}
          />
        );
      }
    }
  };
  renderRetailerModalHtml = () => {
    return (
      <>
        <div className={styles["rtlModalContainer"]}>
          {this.renderBookCover(98, 152)}
          <div className={styles["modal-content"]}>
            <h3 className={styles["afb__title"]}>{this.renderTitle()}</h3>
            <p className={styles["afb__author"]}>{this.renderAuthor()}</p>
            <div className={styles["afb__price"]}>{this.renderBookPrice()}</div>
          </div>
        </div>
        <div>
          <RetailerImageButton {...this.props} />
        </div>
      </>
    );
  };

  /* Previous implementation of buy button */
  renderMultipleBuyButton = () => {
    if (this.props.buttonType == "Url (link)") {
      return this.renderUrlButton();
    } else {
      // I use two name properties to preserve the KM tracking format.
      // The GA format is the same as the display names. - JZ
      let retailers = buildRetailers(this.props);

      // ORMTECH-794 for PORTALIST to remove kobo and google links from posts/book-info/book-listicle etc.
      // can remove this when SEO test is over
      //if (this.props.currentSiteID === SITES.THEPORTALIST && this.props.postType === POST.TYPES.GENERAL){
      // ORMTECH-1347 remove kobo and google links for all site. So removing condition of site id
      if (this.props.postType === POST.TYPES.GENERAL)
        retailers = retailers.filter((link) =>
          link.display === "Google" || link.display === "Kobo" ? null : link
        );
      //}

      let target = "_blank",
        isbn = this.props.primary_isbn,
        buttons = [];

      retailers.forEach((retailer) => {
        if (retailer.url) {
          let eventLabel = `${this.props.title} | ${
              this.props.primary_isbn || this.props.isbns
            } | ${this.props.publisher}`,
            eventAction = "Retail Click";
          buttons.push(
            <>
              {this.props.urlType === "External Link" ? (
                <a
                  href={retailer.url}
                  rel="noopener nofollow sponsored"
                  className={[styles["anc-button"], styles["button"], "button"].join(" ")}
                  data-vars-outbound-url={retailer.url}
                  data-vars-outbound-text={retailer.display}
                  onClick={() =>
                    fireGTMEvent(
                      "Ebook",
                      this.props.title,
                      this.props.primary_isbn,
                      this.props.isbns,
                      this.props.publisher,
                      this.props.isMarketingServices,
                      retailer.kmName,
                      retailer.display
                    )
                  }
                  target={target}
                >
                  {retailer.display}
                </a>
              ) : (
                <a
                  href={retailer.url}
                  rel="noopener nofollow sponsored"
                  className={[styles["anc-button"], styles["button"], "button"].join(" ")}
                  data-vars-event-label={eventLabel}
                  data-vars-event-action={eventAction}
                  data-vars-outbound-url={retailer.url}
                  data-vars-outbound-text={retailer.display}
                  onClick={() =>
                    fireGTMEvent(
                      "Ebook",
                      this.props.title,
                      this.props.primary_isbn,
                      this.props.isbns,
                      this.props.publisher,
                      this.props.isMarketingServices,
                      retailer.kmName,
                      retailer.display
                    )
                  }
                  target={target}
                >
                  {retailer.display}
                </a>
              )}
            </>
          );
        }
      });
      if (buttons.length > 0) {
        return (
          <div className={styles["aff__links"]}>
            {buttons.map((button, index) => {
              return (
                <div className={styles["aff__link"]} key={`aff-btn-${index}`}>
                  {button}
                </div>
              );
            })}
          </div>
        );
      } else {
        return null;
      }
    }
  };

  render() {
    let bookCover = this.renderBookCover();
    let renderNewBuyButton = this.shouldRenderSingleButton();
    let renderBuyButton = renderNewBuyButton
      ? this.renderSingleBuyButton()
      : this.renderMultipleBuyButton();
    let hasRetailerLinks = this.hasRetailerLinks();
    const isScopedPageBuilderUrlButton = this.isScopedPageBuilderUrlButton();

    return (
      <>
        <div 
          className={[
            styles[this.props.className],
            styles["affiliate-button"],
            isScopedPageBuilderUrlButton ? styles["pageBuilderUrlOnly"] : "",
          ].join(" ")}
          style={{
            "--bookListicleAf-display": !this.props.bookInfo ? "none" : "block",
          }}
        >
          <div className={styles["large-12"]}>
            {this.props.className === "bookInfoAf" && !this.props.isMobile ? (
              <>
                <h3 className={styles["afb__title"]}>{this.renderTitle()}</h3>
                <p className={styles["afb__author"]}>{this.renderAuthor()}</p>
              </>
            ) : (
              ""
            )}
            {!this.props.bookInfo ? (
              <React.Fragment>
                {bookCover && (
                  <div className={styles["afb__book-cover"]}>
                    {bookCover}
                    {this.props.freevoice && renderFreeVoiceBanner(210, 60)}
                  </div>
                )}
                <div
                  className={
                    this.props.urlType === "External Link"
                      ? [
                          styles["buttonContainer"],
                          styles["external"],
                          isScopedPageBuilderUrlButton
                            ? styles["pageBuilderUrlButtonContainer"]
                            : "",
                        ].join(" ")
                      : styles["buttonContainer"]
                  }
                >
                  {renderBuyButton}
                </div>
              </React.Fragment>
            ) : (
              <div
                className={
                  this.props.className === "bookInfoAf"
                    ? [styles["bookinfo__container"], styles["bookInfoAfContainer"]].join(" ")
                    : styles["bookinfo__container"]
                }
              >
                {bookCover && hasRetailerLinks && (
                  <div className={styles["afb__book-cover"]}>
                    {this.renderBookCover()}
                    {this.props.freevoice && renderFreeVoiceBanner(210, 60)}
                  </div>
                )}

                {this.props.className === "bookInfoAf" &&
                this.props.isMobile ? (
                  <div className={styles[this.props.className + "mob"]}>
                    <h3 className={styles["afb__title"]}>{this.renderTitle()}</h3>
                    <p className={styles["afb__author"]}>{this.renderAuthor()}</p>
                  </div>
                ) : (
                  ""
                )}
                <div
                  className={
                    this.props.urlType === "External Link"
                      ? [
                          styles["buttonContainer"],
                          styles["external"],
                          isScopedPageBuilderUrlButton
                            ? styles["pageBuilderUrlButtonContainer"]
                            : "",
                        ].join(" ")
                      : styles["buttonContainer"]
                  }
                >
                  {renderBuyButton}
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default ContextConsumer(AffiliateButton);
